/**
 * Encabezado de sección con estilo premium (línea verde lateral).
 */
export const SectionHeader = ({ title }) => `
    <div class="sticky top-0 z-20 bg-base/95 backdrop-blur-md py-4 border-b border-border-subtle mb-2">
        <h2 class="text-[10px] font-black text-text-muted uppercase tracking-[0.3em] flex items-center gap-3">
            <span class="w-4 h-[1.5px] bg-brand"></span>
            ${(title || 'Sección').toString().replace(/\*/g, '')}
        </h2>
    </div>
`;
